<div class="row club-centric-summary-row club-centric-row ">
    <div class="col-4">
        <div class="row">
            <div class="col-6">{{ summaryItem.clubShortName }}</div>
            <div class="col-3 text-center">{{ summaryItem.totalHours | number: '1.1' }}</div>
            <div class="col-3 text-center">{{ summaryItem.totalCost | currency }}</div>
        </div>
    </div>
</div>
<div class="row club-centric-row " *ngFor="let classItem of summaryItem.classes">
    <div class="col-8 offset-4">
        <div class="row align-items-center">
            <div class="col-3">
                {{ classItem.instructor }}
                <span class="club-centric-substitution" *ngIf="classItem.substitution">(sub)</span>
            </div>
            <div class="col-3">
                <span class="ic_cancelled" *ngIf="classItem.cancelled"
                    tooltip="{{ 'ClubCentricReport.CancelledClass' | translate }}" placement="bottom"></span>
                <span class="ic_attendance" *ngIf="!attendanceProvided(classItem)"
                    tooltip="{{ 'ClubCentricReport.ZeroAttendance' | translate }}" placement="bottom"></span>
                {{ classItem.className }}
            </div>
            <div class="col-3">{{ classItem.bcDate | bcDate: 'MMM DD' }}, {{ classItem.startTime | timeDisplay }}</div>
            <div class="col-1 text-left">{{ classItem.actualLengthOfClass }}</div>
            <div class="col-1 text-left">{{ classItem.billableLengthOfClass }}</div>
            <div class="col-1 text-center p-0">{{ classItem.cost | currency }}</div>
        </div>
    </div>
</div>
